var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import styled from "styled-components";
import ScrollTo from "../../scroll-to";
export var Container = styled(ScrollTo)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: 1.2rem;\n  line-height: 1.8rem;\n  padding: 0;\n  appearance: none;\n  background-color: transparent;\n  border: 0;\n  cursor: pointer;\n"], ["\n  font-size: 1.2rem;\n  line-height: 1.8rem;\n  padding: 0;\n  appearance: none;\n  background-color: transparent;\n  border: 0;\n  cursor: pointer;\n"])));
var templateObject_1;